import type { useAufnahme } from '../aufnahme'
import { dauer } from '../tagebuch'

export function AufnahmeLeiste({ aufnahme, onTippen }: { aufnahme: ReturnType<typeof useAufnahme>; onTippen: () => void }) {
  const { zustand } = aufnahme

  if (zustand.art === 'laeuft') {
    return (
      <div className="aufnahme-laeuft" role="status">
        <div className="aufnahme-zeit">
          <span className="punkt" aria-hidden="true" />
          {dauer(aufnahme.dauerMs)}
        </div>
        <div className="pegel" aria-hidden="true">
          <div style={{ transform: `scaleX(${Math.max(0.03, aufnahme.pegel)})` }} />
        </div>
        <div className="aufnahme-knoepfe">
          <button className="zweitrangig" onClick={aufnahme.abbrechen}>
            Verwerfen
          </button>
          <button onClick={aufnahme.stoppen}>Fertig</button>
        </div>
      </div>
    )
  }

  return (
    <div className="aufnahme-leiste">
      {zustand.art === 'fehler' && (
        <p className="hinweis fehler" onClick={aufnahme.fehlerQuittieren}>
          {zustand.meldung}
        </p>
      )}
      <button className="tippen" onClick={onTippen} aria-label="Notiz tippen">
        ✎
      </button>
      <button className="aufnehmen" onClick={aufnahme.starten} aria-label="Aufnahme starten">
        <span />
      </button>
    </div>
  )
}
